import { render } from "./UserScore.vue?vue&type=template&id=2ea11d28&scoped=true"
import script from "./UserScore.vue?vue&type=script&lang=js"
export * from "./UserScore.vue?vue&type=script&lang=js"

import "./UserScore.vue?vue&type=style&index=0&id=2ea11d28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ea11d28"]])

export default __exports__